import React, { useState, useEffect } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
const PTReports = () => {
    const [PTR, SetPTR] = useState([]);
    const [Load, SetLoad] = useState(false);
    const [SSubject, SetSSubject] = useState(1);
    const Columns = [
        { name: "Email", selector: "email", sortable: true, },
        { name: "Grade", selector: "grade", sortable: true, },
        { name: "Subject", selector: "subjectName", sortable: true, },
        ...(SSubject != 3 ? [{ name: "Topic", selector: "topicName", sortable: true, }] : []),
        ...(SSubject === 3 ? [
            { name: "Book", selector: "bookName", sortable: true, },
            { name: "Main Reading", selector: "mainreadingpoemName", sortable: true, },
            { name: "Poem", selector: "poemName", sortable: true, },
            { name: "Non-Detailed Lesson", selector: "nonDetailedLessonName", sortable: true, },
            { name: "Grammar", selector: "grammerName", sortable: true, },
        ] : []),
        { name: "No.of Questions", selector: "noofquestions", sortable: true, },
        { name: "Correct Answers", selector: "correctAnswers", sortable: true, },
        { name: "Attempted date time", selector: "attendedDate", sortable: true, },
        { name: "Attempt No", selector: "attemptNo", sortable: true, },
    ];
    const GetParticipationDetails = async () => {
        SetLoad((prev) => !prev);
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetPracticeTestTrack?SubjectId=${SSubject}`);
        //  const Filterdata = res.data.filter((Email) => Email.subjectId === SSubject)
            SetPTR(res.data);
            SetLoad((prev) => !prev);
        }
        catch (err) { console.log(err); }
    }
    useEffect(() => { GetParticipationDetails(); }, [SSubject])
    const Subjects = [
        { display: "Mathematics", value: 1 },
        { display: "Science", value: 2 },
        { display: "English", value: 3 },
        // { display: "Hindi", value: 4, Icon: <RiTranslate /> },
        // { display: "Telugu", value: 5, Icon: <MdOutlineLanguage /> },
    ];
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="dflex alignitems JSBetween">
                    <div></div>
                    <div className="MainHeading"> Practice Test tracking</div>
                    <DropdownValues className="NCLDropdown" options={Subjects} onChange={(e) => SetSSubject(parseInt(e.target.value))} />
                </div>
                <DataTable className="NCLDataTable Card mt-3" data={PTR} columns={Columns} ShowPagination={true}
                    ShowPagecount={true} />
            </div>
            {Load && <Loading />}
        </>
    )
}
export default PTReports;